import React, { useEffect, useState }from "react";
import { Button, Modal, Form, Input, notification } from "antd";
import _ from 'lodash';
import styled from "styled-components";

const ExpiredPasswordModal = ({ visible, onClose, loginPath, Auth, loginValues, loginCallback }) => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [form] = Form.useForm();

  const formItemLayout = {
    labelCol: {
        xs: { span: 8 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 },
    },
  };

  const onCancel = () => {
    onClose();
    setError('');
  }

  const handleSubmit = (formValues) => {
    setLoading(true);
    setError('');
		Auth.changePassword(loginValues.username,
			loginValues.password,
			formValues.password,
			loginValues.server,
			loginValues.repository,
      loginPath,
			function (authorized, redirect, message) {
				if (!authorized) {
					setError(message);
          setLoading(false);
          form.resetFields();
				} else {
          notification.success({ message: `Password has been changed.` });
          loginCallback(authorized, redirect, message);
				}
			});

  }

  return (
    <Modal
      visible={visible}
      width="500px"
      title={`Your password has expired`}
      forceRender={true}
      destroyOnClose={true}
      maskClosable={false}
      onCancel={onCancel}
      footer={null}
    >
			<ErrorMessage>{error}</ErrorMessage>
      <Form form={form} onFinish={handleSubmit} {...formItemLayout} autoComplete="off" name="changePasswordForm" hideRequiredMark>
        <Form.Item
          label="New Password"
          name="password"
          style={{ marginBottom: '8px',  }}
          rules={[
            {
              required: true,
              message: 'Please enter new password',
            }
          ]}
        >
            <Input
              autoFocus
              type="password"
              style={{ width: '100%' }}
            />
        </Form.Item>
        <Form.Item
					label="Confirm Password"
					name="confirmPassword"
					style={{ marginBottom: '8px',  }}
					dependencies={['password']}
					rules={[
						{
							required: true,
							message: 'Please confirm new password',
						},
						({ getFieldValue }) => ({
							validator(_, value) {
								if (!value || getFieldValue('password') === value) {
									return Promise.resolve();
								}
	
								return Promise.reject(new Error('Passwords do not match'));
							},
						}),
					]}
				>
            <Input type="password" style={{ width: '100%' }}/>
        </Form.Item>
        <Form.Item
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 24 },
          }}
          style={{ margin: '25px 0 0 0' }}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{ float: 'right', marginLeft: '10px' }}
            loading={loading}>
            Submit
          </Button>
          <Button
            style={{ float: 'right' }}
            onClick={onCancel}>
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const ErrorMessage = styled.pre`
  overflow: hidden;
  white-space: pre-wrap;
  font-family: inherit;
	font-size: 13px;
	margin-bottom: 20px;
	display: block;
`

export default ExpiredPasswordModal;
